import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=701bb290&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bb290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701bb290')) {
      api.createRecord('701bb290', component.options)
    } else {
      api.reload('701bb290', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=701bb290&scoped=true&", function () {
      api.rerender('701bb290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/ContactForm.vue"
export default component.exports